export default {
  path: '/user',
  name: 'user',
  redirect: { name: 'user.profile-page' },
  component: () => import(/* webpackChunkName: "user" */ '@/views/user'),
  children: [
    {
      path: '/profile',
      name: 'user.profile-page',
      component: () =>
        import(
          /* webpackChunkName: "profile-page" */ '@/views/user/ProfilePage.vue'
        )
    },
    {
      path: '/settings',
      name: 'user.settings-page',
      component: () =>
        import(
          /* webpackChunkName: "settings-page" */ '@/views/user/SettingsPage.vue'
        )
    },
    {
      path: '/verify',
      name: 'user.verify-page',
      component: () =>
        import(
          /* webpackChunkName: "verify-page" */ '@/views/user/VerifyPage.vue'
        )
    }
  ]
}
